export function validateRequiredParts(source, catalog) {
  if (!source || !catalog) return [];
  const parts = source.parts || [];
  const names = new Set(parts.map((p) => p.partType));
  const issues = [];
  (catalog.required_parts || []).forEach((requiredPart) => {
    if (!names.has(requiredPart)) {
      issues.push({
        level: 'hard',
        code: 'missing_required_part',
        message: `Отсутствует обязательная деталь: ${requiredPart}`,
        partType: requiredPart,
      });
    }
  });
  return issues;
}
